/** Restore a report filter from the screen URL, falling back to its normal default. */
export function reportFilterValue(
  params: URLSearchParams,
  key: string,
  fallback: string,
): string
export function reportFilterValue(
  params: URLSearchParams,
  key: string,
  fallback: boolean,
): boolean
export function reportFilterValue(
  params: URLSearchParams,
  key: string,
  fallback: string | boolean,
): string | boolean
export function reportFilterValue(
  params: URLSearchParams,
  key: string,
  fallback: string | boolean,
): string | boolean {
  if (!params.has(key)) return fallback
  const value = params.get(key) ?? ""
  return typeof fallback === "boolean" ? value === "true" : value
}

export function restoreReportFilterValues(
  defaults: Record<string, string | boolean>,
  params: URLSearchParams,
): Record<string, string | boolean> {
  return Object.fromEntries(
    Object.entries(defaults).map(([key, fallback]) => [
      key,
      reportFilterValue(params, key, fallback),
    ]),
  )
}

export function reportFilterReturnHref(pathname: string, params: URLSearchParams): string {
  const parentPath = pathname.replace(/\/(view|screen)$/, "")
  const query = params.toString()
  return query ? `${parentPath}?${query}` : parentPath
}
